export default "__VITE_ASSET__DH4e4CqL__"